/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class CategoryListResponseModel {

  public categoryId: number;
  public categoryName: string;
  public vendorCategoryCommission: number;
  public vendorCategoryId: number;
  public vendorId: number;

  constructor(categoryResponse: any) {
    this.categoryId = categoryResponse.categoryId || '';
    this.categoryName = categoryResponse.categoryName || '';
    this.vendorCategoryCommission = categoryResponse.vendorCategoryCommission || '';
    this.vendorCategoryId = categoryResponse.vendorCategoryId || '';
    this.vendorId = categoryResponse.vendorId || '';

  }
}
